var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "30px",
    viewBox: "0 0 24 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "94C51264-DA3E-4512-A098-C64BDBE556A4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Guidemark-Admin-Desktop-Worklog-submitted",
    transform: "translate(-324.000000, -517.000000)",
    fill: "#5286F7",
    fillRule: "nonzero",
    stroke: "#5286F7",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Work-log-/-Admin-/-Sumbitted-/-Card-expanded",
    transform: "translate(310.000000, 244.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(12.000000, 248.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(0.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Document-/-Blue",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9100683,8.39626667 L17.3503795,0.444266667 C17.0968239,0.178266667 16.679935,0 16.3134461,0 L5.25562393,0 C3.54513504,0 2.15384615,1.3916 2.15384615,3.10177778 L2.15384615,24.8982222 C2.15384615,26.6084 3.54513504,28 5.25562393,28 L22.2161572,28 C23.9266461,28 25.3182461,26.6084 25.3182461,24.8982222 L25.3182461,9.41826667 C25.3182461,9.06422222 25.1542906,8.65386667 24.9100683,8.39626667 Z M17.3534905,2.6120889 L22.8349573,8.37822221 L18.3751794,8.37822221 C17.8117572,8.37822221 17.3534905,7.91964443 17.3534905,7.35653332 L17.3534905,2.6120889 L17.3534905,2.6120889 Z M23.8270915,24.8982214 C23.8270915,25.7861325 23.1040693,26.5091547 22.2161581,26.5091547 L5.25562399,26.5091547 C4.36771284,26.5091547 3.64469059,25.7864436 3.64469059,24.8982214 L3.64469059,3.10177776 C3.64469059,2.21386668 4.36740173,1.49084448 5.25562399,1.49084448 L15.8626467,1.49053337 L15.8626467,7.35622204 C15.8626467,8.74191088 16.9898023,9.86906639 18.3751801,9.86906639 L23.8267804,9.86906639 L23.8267804,24.8982214 L23.8270915,24.8982214 Z",
    id: "file"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document-icon.412640fd0b14c4b58b577a281cd00fee.svg";
export { ForwardRef as ReactComponent };